import { ReactComponent as BkgComponent } from '../assets/bkg-slovak.svg';
import SvgRouteNavigator from '../components/SvgRouteNavigator';

const linkRoutes: Record<string, string> = {
  "link-cycle-1": "/slovak/cycle/1",
  "link-cycle-2": "/slovak/cycle/2",
  "link-cycle-3": "/slovak/cycle/3",
  "link-misc": "/slovak/misc",
  "link-back": "/main",
};

function Slovak() {
  return <SvgRouteNavigator SvgComponent={BkgComponent} linkRoutes={linkRoutes} />;
}

export default Slovak;
